import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const irThemeDark = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#F58077',
      },
      secondary: {
        main: '#1f2124',
      },
      error: {
        main: '#E62D1E',
      },
      warning: {
        main: '#f29f05',
      },
      info: {
        main: '#0c4e99',
      },
      success: {
        main: '#528a04',
      },
      background: {
        default: '#1F2124',
        paper: '#575C63',
      },
      banner: {
        info: '#0c4e99',
        error: '#E62D1E',
        text: '#343b58',
        link: '#565a6e',
      },
      errorBackground: '#8c4351',
      warningBackground: '#8f5e15',
      infoBackground: '#343b58',
      navigation: {
        background: '#1F2124',
        indicator: '#D42A1D',
        color: '#ffffff',
        selectedColor: '#ffffff',
      },
    },
  }),
  pageTheme: {
    home: genPageTheme({ colors: ['#d42a1d', '#1F2124'], shape: shapes.wave }),
  },
  fontFamily: 'Roboto,sans-serif',
  defaultPageTheme: 'home',
});
